import React, { useRef } from 'react'

// Services
import I18n from 'APP/Services/i18n'
import Typography from 'APP/Converse/Typography'
import Button from 'APP/Converse/Button'
import { ButtonContainer, Container, FileInputContainer, OldContainer } from './style'
import { useFilePicker } from 'APP/Hooks/FilePicker.web'
import FileUploadInput from 'APP/Converse/Inputs/FileUploadInput'
import { featuresState } from 'APP/Sagas/FeaturesSaga'
import { useSelector } from 'react-redux'

interface IntakePhotoProps {
  sendAnswer: (answer: any) => void // @todo: ANY - be more specific here
  disabled: boolean
}

const IntakePhoto: React.FC<IntakePhotoProps> = ({ sendAnswer, disabled }) => {
  const inputFile = useRef<HTMLInputElement>(null)
  const { enableFileUploadComponent } = useSelector(featuresState)
  const { openFilePicker, onFileChange, file, hasFile, onSubmitPress, isFileTypeValid } =
    useFilePicker({
      submitCallback: sendAnswer,
      fileInputRef: inputFile,
    })

  return (
    enableFileUploadComponent ? (
      <Container>
        <FileInputContainer>
          <FileUploadInput title={I18n.t('FileUploadInput.defaultTitle')} onPress={openFilePicker} />
        </FileInputContainer>
        <input
          type="file"
          accept="image/*,.pdf"
          ref={inputFile}
          style={{ display: 'none' }}
          onChange={onFileChange}
        />
        {hasFile && (
          <Typography
            variant="bodyLarge"
            tabIndex="0"
            type="bodyLarge"
            align="right"
          >
            {file?.name}
          </Typography>
        )}
        <ButtonContainer>
          {hasFile && (
            <Button
              id="prompt-file-submit-button"
              title={I18n.t('IntakeComponent.next')}
              onPress={onSubmitPress}
              disabled={!isFileTypeValid(file?.type)}
            />
          )}
        </ButtonContainer>
      </Container>
    ) : (
        <OldContainer>
          <input
            type="file"
            accept="image/*,.pdf"
            ref={inputFile}
            style={{ display: 'none' }}
            onChange={onFileChange}
          />
          {hasFile && (
            <Typography
              variant="bodyLarge"
              tabIndex="0"
              type="bodyLarge"
              align="left"
            >
              {file?.name}
            </Typography>
          )}
          <ButtonContainer>
            {hasFile && (
              <Button
                id="prompt-file-submit-button"
                title={I18n.t('IntakeComponent.next')}
                onPress={onSubmitPress}
                disabled={!isFileTypeValid(file?.type)}
              />
            )}
            <Button
              id="prompt-file-upload-button"
              variant="secondary"
              title={I18n.t('IntakeComponent.upload')}
              onPress={openFilePicker}
              disabled={disabled}
            />
          </ButtonContainer>
        </OldContainer>
      )
  )
}

export default IntakePhoto
